import { useEffect, useState } from "react";
import styled from "styled-components";
import Proceed from "../components/Proceed";
import researchData from '../data/research_data.json';
import images from '../img';

function Question({
    graphic,
    proceed = 0,
    setAnswer,
    step,
    wholeProceed
}) {
    const questionLength = 8;
    const currentData = researchData.filter(x => x.step === step);
    const answers = currentData[proceed].answers;
    const question = currentData[proceed].question;
    const type = currentData[proceed].type;
    const emphasis = currentData[proceed].emphasis;

    const data = {
        question: question || "당신은 누구와 함께 살고 있나요?",
        emphasis: emphasis || [4, 11],
        proceed: proceed,
        graphic: graphic || "",
        percentage: (wholeProceed) * 100 / questionLength,
        answers: answers || [
            { text: "일단 행동하면서 실행하는 직관력", type: "장" },
            { text: "상대방의 마음을 잘 알아차리는 센스와 공감력", type: "가슴" },
            { text: "사실에 근거한 논리적이고 객관적인 사고력", type: "머리" },
        ]
    };
    const questions = [
        data.question.slice(0, data.emphasis[0]).trim(),
        data.question.slice(data.emphasis[0], data.emphasis[1]).trim(),
        data.question.slice(data.emphasis[1]).trim()
    ];

    return (<QuestionStyleWrapper>
        <div className="question-body">
            <Proceed className="question-proceed-mobile" percentage={data.percentage} />
            <div className="question-section">
                <div className="question">
                    {questions[0]}
                    <div className="emphasis">
                        {questions[1]}
                    </div>
                    {questions[2]}
                    <div className="question-graphic">
                        <img src={images["icon/" + currentData[proceed].icon]} />
                    </div>
                </div>
                <Proceed className="question-proceed" percentage={data.percentage} />
            </div>
            <div className="answer-section">
                {data.answers.map((x, i) =>
                    <AnswerBtn className={
                        "answer-btn" + (data.answers.length < 4 ? " answer-btn-100" : "")
                    } key={i}
                        onClick={() => {
                            setAnswer(
                                x,
                                currentData[proceed].lastOfStep,
                                type === "tiebreaker",
                                currentData[proceed],
                            );
                        }}
                        dangerouslySetInnerHTML={{
                            __html: x.text
                        }}
                    >

                    </AnswerBtn>)}
                <div className="backbtn-wrap">
                    <img onClick={() => { window.history.back() }} className="backbtn" src={images["btn_back.png"]} />
                </div>
            </div>
        </div>
        <div className="question-footer">
            <img className="logo" src={images["zin_logo-white.png"]} />
        </div>
    </QuestionStyleWrapper>);
}

export default Question;

const QuestionStyleWrapper = styled.div`
    height:100%;
    width:100%;
    display: flex;
    flex-direction: column;
    .question-proceed-mobile{
        display: none;
    }
    .answer-section{
        flex-grow: 1;
        margin:-2.5rem;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        .answer-btn{
            margin:2.5rem;
            width:calc(50% - 5rem);
            &.answer-btn-100{
                margin:2.5rem 0;
                width:100%;
            }
        }
        .backbtn{
            display: none;
        }
    }
    .question-section{
        width:51.4rem;
        flex-shrink: 0;
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-right:12.8rem;
        .question-graphic{
            margin-top:6.11rem;
            img{
                height: 11.6rem;
            }
        }
        .question-proceed{
            display: flex;
            align-items: center;
        }
    }
    .question{
        font-size: 6.1rem;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.41;
        letter-spacing: normal;
        text-align: left;
        color: #000;
        word-break: keep-all;
        .emphasis{
            font-weight: 700;
            font-size: 10rem;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.41;
            letter-spacing: normal;
            text-align: left;
            color: #7b0d10;
        }
    }
    .question-body{
        flex-grow: 1;
        width:100%;
        margin:auto;
        box-sizing: border-box;
        padding:16rem 14.3rem 15.4rem;
        display: flex;
    }
    .question-footer{
        height:110px;
        flex-shrink: 0;
        background-color: #000;
        display: flex;
        align-items: center;
        justify-content: right;
        padding-right:7.8rem;
        .logo{
            height:27px;
        }
    }
    @media screen and (max-width:990px){
        position:relative;
        .answer-section{
            .answer-btn{
                width: 100%;
            }
            .backbtn-wrap{
                display: flex;
                justify-content: flex-end;
                margin-top:1.8rem;
            }
            .backbtn{
                display: block;
                height:3.2rem;
                cursor: pointer;
                &:hover{
                    opacity: 0.8;
                }
            }
        }
        .question-footer{
            display: none;
        }
        .question-proceed-mobile{
            width: calc(100vw - 8.8rem);
            position:absolute;
            top:2rem;
            right:2rem;
            display: flex;
            align-items: center;
            .proceed-container{
                height:0.5rem;
            }
            .percentage{
                color:#6f7175;
                font-size:1.3rem;
            }
        }
        .question-section{
            width: 100%;
            position:relative;
            .question-proceed{
                display: none;
            }
            .question-graphic{
                margin-bottom:1.6rem;
                height:6.1rem;
            }
        }
        .question-body{
            display: flex;
            flex-direction: column;
            padding:7rem 2.5rem;
        }
        .answer-section{
            width: 100%;
            margin:0;
            flex-direction: column;
            .answer-btn.answer-btn-100,
            .answer-btn{
                margin:1rem 0;
                box-sizing: border-box;
            }
        }
        .question-section{
            height: auto;
            .question-graphic{
                display: flex;
                justify-content: flex-end;
                margin-top:0;
                margin-bottom:2.86rem;
                img{
                    height: 2.4em;
                }
            }
        }
        .question{
            font-size:3.2rem;
            line-height: 1.06;
            .emphasis{
                font-size: 4.7rem;
            }
        }
    }
`;

const AnswerBtn = styled.button`
    border-radius: 10px;
    background-color: #f0f0f0;
    font-size: 4.3rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.43px;
    text-align: center;
    color: #000;
    border:0;
    cursor:pointer;
    word-break: keep-all;
    transition: background-color ease-in-out .2s, color ease-in-out .2s;
    &:hover{
        background-color:#7b0d10;
        color: #fff;
    }
    @media screen and (max-width:990px){
        font-size:2.2rem;
        padding:2.3rem 1.3rem;
        box-sizing: border-box;
    }
`;